import { ReactElement } from 'react';
import cc from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import { createArray } from 'utils/helpers/create-fake-array';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

const CATEGORIES_VERTICAL_COUNT = 10;

export const CategoriesVerticalSkeleton = ({
  fromSideBar,
  namesOnly,
  gamesCount
}: {
  fromSideBar?: boolean;
  namesOnly: boolean;
  gamesCount: boolean;
}): ReactElement => {
  return (
    <div className="categoriesVertical__wrapper">
      {!fromSideBar ? (
        <h4 className="categoriesVertical__title">
          <Skeleton
            title={{
              style: {
                height: 16,
                width: 125,
                margin: '4px 0px'
              }
            }}
            paragraph={false}
            active
          />
        </h4>
      ) : null}
      <div
        className={cc([
          'categoriesVertical__items__container',
          {
            'categoriesVertical__items__container--fromSidebar': fromSideBar
          }
        ])}
      >
        {createArray(CATEGORIES_VERTICAL_COUNT).map(key => (
          <div
            className="categoriesVertical__item categoriesVertical__item--noHover"
            key={key}
          >
            <div
              className={cc([
                'categoriesVertical__item__info',
                { 'casino-sidebar-skeleton': fromSideBar }
              ])}
            >
              {!namesOnly && (
                <span className="categoriesVertical__item__icon">
                  <Skeleton.Avatar size={EIconSize._24} active />
                </span>
              )}
              <div className="categoriesVertical__item__label">
                <Skeleton
                  title={{
                    style: {
                      height: 12,
                      width: 125,
                      margin: '2px 0'
                    }
                  }}
                  paragraph={false}
                  active
                />
              </div>
            </div>
            {gamesCount && (
              <div className="categoriesVertical__item__count">
                <Skeleton
                  title={{
                    style: {
                      height: 12,
                      width: 20,
                      margin: '0',
                      float: 'right'
                    }
                  }}
                  paragraph={false}
                  active
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
